import { ELOQUA } from "../../utilities/enums";
import HttpService from "../../services/HttpService";

export async function sendCalculatorsQuote(emailDetails: FormData): Promise<boolean> {
    try {
        return await HttpService.post(ELOQUA.URL, emailDetails, { headers: { "Content-Type": "multipart/form-data" } });
    } catch (e) {
        handleError(e);
    }
}

const handleError = (error: any) => {
    const errorMsg = error.message;
    return errorMsg;
};
